var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.435 17.881l4.728 2.996c.605.383 1.355-.187 1.176-.892l-1.366-5.374a.821.821 0 01.266-.832l4.24-3.53c.557-.463.27-1.388-.447-1.434l-5.537-.36a.79.79 0 01-.68-.501l-2.064-5.2a.78.78 0 00-1.459 0l-2.065 5.2a.79.79 0 01-.68.501l-5.537.36c-.715.046-1.003.97-.446 1.435l4.24 3.529a.82.82 0 01.266.832l-1.267 4.983c-.215.847.686 1.53 1.41 1.071l4.395-2.784a.77.77 0 01.827 0v0z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgStar;